import React from 'react';

// Small, quiet language link for CMS twins. Greek page → "English"; EN page → "Ελληνικά".
export default function LangSwitch({ lang, href, className = '' }) {
  if (!href) return null;
  const toEn = lang !== 'en';
  return (
    <a
      href={href}
      hrefLang={toEn ? 'en' : 'el'}
      lang={toEn ? 'en' : 'el'}
      className={`ml-auto inline-flex items-center gap-1.5 text-tiny text-muted hover:text-warm-black transition-colors ${className}`}
    >
      {toEn ? 'English' : 'Ελληνικά'} <span aria-hidden="true" className="text-gold">→</span>
    </a>
  );
}
